module.exports = __webpack_public_path__ + "img/20200516_095142.a1ebb9b6.jpg";